import { Injectable } from '@angular/core';
import { TranslationsService } from '../services/translations.service';
import { ColumnDefiner, ColumnDefinitions, ColumnGroup } from './column-group.class';
import { noAndNotAssignedNegativeCssClass } from '../helpers/data.helpers';
import { courseStatusCssClass } from '../helpers/courses.helpers';
import { CommonService } from '../services/common.service';
import { courseActivityStatusDataMap, driveWorkDataMap } from '../data/data-maps/courses';

@Injectable({ providedIn: 'root' })
export class CoursesColumns extends ColumnGroup {
  public constructor(private translations: TranslationsService, private commonService: CommonService) {
    super();
  }

  protected columnDefinitions: ColumnDefinitions = {
    driverDetailsFuelType: {
      valueFormatter: (params) => this.translations.translate(`REPORTDATA.${params.value}`, params.value),
    },
    travelForWork: () => ({
      refData: this.translations.translateDataMap(driveWorkDataMap),
      cellClass: (params) => noAndNotAssignedNegativeCssClass(params.api.getValue('travelForWork', params.node)),
    }),
    trainingActivityStatus: () => ({
      width: 150,
      refData: this.translations.translateDataMap(courseActivityStatusDataMap),
      cellClass: (params) =>
        courseStatusCssClass(
          params.api.getValue('trainingActivityStatus', params.node),
          this.commonService.userProfile.userPermissions.permDueDates === this.commonService.permLevels.TRUE
        ),
    }),
  };

  public getColumnDefinition(columnName: string): ColumnDefiner | null {
    if (
      columnName.startsWith('question') &&
      (columnName.endsWith('vehicle_fuel') || columnName.endsWith('fueltype') || columnName.endsWith('fuel_type'))
    ) {
      return this.columnDefinitions.driverDetailsFuelType;
    }

    return super.getColumnDefinition(columnName);
  }
}
